var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMagnifyingGlassWithPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 32691"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m18.778 20-7.306-7.306a6.1 6.1 0 0 1-1.944 1.125 6.9 6.9 0 0 1-2.361.4 6.92 6.92 0 0 1-5.083-2.083A6.85 6.85 0 0 1 0 7.111a6.85 6.85 0 0 1 2.083-5.028A6.88 6.88 0 0 1 7.139 0a6.8 6.8 0 0 1 5.014 2.083 7.11 7.11 0 0 1 1.681 7.333 7 7 0 0 1-1.167 2.083L20 18.778ZM7.139 12.556a5.2 5.2 0 0 0 3.833-1.6 5.27 5.27 0 0 0 1.583-3.847 5.27 5.27 0 0 0-1.583-3.847 5.2 5.2 0 0 0-3.833-1.6 5.28 5.28 0 0 0-3.875 1.6 5.24 5.24 0 0 0-1.6 3.847 5.24 5.24 0 0 0 1.6 3.847 5.28 5.28 0 0 0 3.875 1.6"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 31791"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.08 4.317a.374.374 0 0 0-.374.374v2.093H4.613a.374.374 0 0 0 0 .748h2.093v2.093a.374.374 0 1 0 .748 0V7.532h2.093a.374.374 0 0 0 0-.748H7.454V4.691a.374.374 0 0 0-.374-.374",
  "data-name": "Path 4404"
})))));
export default SvgIconMagnifyingGlassWithPlus;